export default [
  {
    path: "/keuangan/dashboard",
    name: "keuangan-dashboard",
    component: () => import("../../views/rektorat/keuangan/Dashboard.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Keuangan", active: true },
      ],
      pageTitle: "Dashboard Keuangan",
    },
  },
];
